import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@internations/ds';
import { ReactElement } from 'react';
export const LayoutChildSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="mt-5"><Skeleton variant="rectangular" height="10rem" /><Skeleton height="40px" /><Skeleton height="40px" /><Skeleton height="40px" /><Skeleton height="40px" className="mt-2" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};